export default __webpack_public_path__ + "static/media/CC1B579C-C098-4D1E-B67F-A3F0FF513C57_1_105_c.12f51655.jpeg";